export default __webpack_public_path__ + "static/kayiAccountImg-eff5c620a6e8b41ee4d4bfc89c9a6f4a.png";